import { Routes } from '@angular/router';
import { WarrantiesOverviewService } from '@app/admin/warranties/overview/services/warranties-overview.service';
import { AddService } from '@app/admin/warranties/add/services/add.service';

export const warrantiesRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/warranties/overview/overview.component').then(component => component.OverviewComponent),
    providers: [WarrantiesOverviewService,],
  },
  {
    path: 'add',
    loadComponent: () => import('@app/admin/warranties/add/add.component').then(component => component.AddComponent),
    providers: [AddService],
  },
  {
    path: ':id',
    loadComponent: () => import('@app/admin/warranties/details/details.component').then(component => component.DetailsComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
